export const BillingIndividualTariffsColumns = [
    {
        name: 'Компания',
        key: 'name',
    },
    {
        name: 'БИН',
        key: 'bin',
    },
    {
        name: 'Статус',
        key: 'billing',
    },
]

export const TariffsFtlColumns = [
    {
        name: 'Компания',
        key: 'shortName',
    },
    {
        name: 'БИН',
        key: 'bin',
    },
    {
        name: 'Статус',
        key: 'vatEnabled',
    },
]
